// WhatsApp reminder utility for fee reminders

export function getWhatsAppReminderUrl(phone, studentName, amount, month, year, type = 'monthly') {
  // Clean phone number - remove spaces, dashes, add country code if needed
  let cleanPhone = phone?.replace(/[\s-()]/g, '') || '';
  // Add India country code if not present
  if (cleanPhone.startsWith('0')) cleanPhone = cleanPhone.substring(1);
  if (!cleanPhone.startsWith('+') && !cleanPhone.startsWith('91')) {
    cleanPhone = '91' + cleanPhone;
  }
  if (cleanPhone.startsWith('+')) cleanPhone = cleanPhone.substring(1);

  const feeType = type === 'admission' ? 'Admission Fee' : 'Monthly Fee';
  const message = `Dear ${studentName},\n\nThis is a friendly reminder from *SIGNATURE PSC COACHING CENTRE*, Palachira, Varkala.\n\nYour ${feeType} of *₹${amount}* for *${month} ${year}* is pending. Kindly make the payment at the earliest.\n\nThank you for being a valued student!\n\n— Signature PSC Coaching Centre\nPhone: 8281583404`;

  return `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;
}

export function getBulkReminderData(pendingFees, students) {
  const studentMap = {};
  students.forEach(s => { studentMap[s.student_id] = s; });

  return pendingFees
    .filter(f => f.status === 'pending')
    .map(f => {
      const student = studentMap[f.student_id];
      if (!student) return null;
      return {
        student_id: f.student_id,
        name: student.name,
        phone: student.phone,
        amount: f.amount,
        month: f.month,
        year: f.year,
        type: f.type,
        url: getWhatsAppReminderUrl(student.phone, student.name, f.amount, f.month, f.year, f.type)
      };
    })
    .filter(Boolean);
}
